import { INPUT_FIELD_NAMES } from "nlib/common/ContactForm/constants";
import { getTextsData } from "selectors/texts";
import { useSelector } from "react-redux";
import Input from "nlib/ui/Input";
import React from "react";
import useContactFormContext from "nlib/common/ContactForm/useContactFormContext";

const ContactFormStreetInput = (props) => {
  const { uiTexts } = useSelector(getTextsData);

  const { value, disabled, readOnly, onChange } = useContactFormContext(INPUT_FIELD_NAMES.STREET);

  return (
    <Input
      placeholder={uiTexts.enterStreetName}
      {...props}
      disabled={disabled}
      readOnly={readOnly}
      value={value || ""}
      onChange={onChange} />
  );
};

export default React.memo(ContactFormStreetInput);
